const businessPlanMg = {
  id: "businessplan-mg",
  nom: "BusinessPlan.mg",
  description:
    "Plateforme SaaS de génération de business plans pour les entrepreneurs incubés du projet Miary (Cabinet Esprit d'Entreprise). Architecture multi-rôles — incubé, coach, administrateur — avec parcours d'accompagnement différenciés, rédaction guidée en 14 étapes, prévisionnel financier automatisé (compte de résultat, VAN/TRI, ratios) et export PDF à la charte du cabinet. La rédaction d'un business plan passe de dix jours à trois heures. 82 utilisateurs et 63 business plans produits à ce jour.",
  description_en:
    "A SaaS platform generating business plans for entrepreneurs incubated by the Miary programme (Esprit d'Entreprise consultancy). Multi-role architecture — entrepreneur, coach, administrator — with differentiated support paths, a guided 14-step editor, automated financial forecasting (income statement, NPV/IRR, ratios) and PDF export in the firm's brand. Drafting a business plan drops from ten days to three hours. 82 users and 63 business plans produced so far.",
  image: "/assets/img/businessplan/tableau-de-bord.webp",
  galerie: [
    "/assets/img/businessplan/tableau-de-bord.webp",
    "/assets/img/businessplan/administration.webp",
    "/assets/img/businessplan/redaction-etape-1.webp",
    "/assets/img/businessplan/previsionnel-financier.webp",
    "/assets/img/businessplan/suivi-incubes.webp",
    "/assets/img/businessplan/journal-activite.webp",
  ],
  // Code propriété du cabinet client : pas de dépôt public.
  privateCode: true,
  technologies: [
    { nom: "Next.js 14", image: "/assets/img/icon/stack/react.webp" },
    { nom: "TypeScript", image: "/assets/img/icon/stack/JavaScript-logo.webp" },
    { nom: "Prisma", image: "/assets/img/icon/stack/postgre.webp" },
    { nom: "PostgreSQL", image: "/assets/img/icon/stack/postgre.webp" },
  ],
};

const lahimena = {
  id: "lahimena",
  nom: "Lahimena",
  description:
    "Logiciel de gestion pour une agence de voyage, couvrant le cycle client complet : demande, itinéraire, cotation, devis, facturation et comptabilité — plus de 100 modules livrés en production. Moteur de cotation multi-prestations (hôtellerie avec rooming SGL/DBL/TWN/TPL/FML, transport, billetterie, excursions), conversion de devises via API de taux et génération PDF. Sécurité applicative : PBKDF2-HMAC-SHA256, protection anti-brute-force, RBAC à 3 rôles appliqué jusqu'à la navigation, et module d'audit traçant toutes les actions. Module comptable TsaraKonta : bilan, compte de résultat, flux de trésorerie, ratios, amortissements et prévisions à 5 ans. Industrialisé avec 111 tests unitaires et une CI GitHub Actions à lint bloquant.",
  description_en:
    "A management application for a travel agency covering the full client cycle: enquiry, itinerary, quotation, estimate, invoicing and accounting — over 100 modules shipped to production. Multi-service quotation engine (hotels with SGL/DBL/TWN/TPL/FML rooming, transport, ticketing, excursions), currency conversion through a rates API and PDF generation. Application security: PBKDF2-HMAC-SHA256, brute-force protection, 3-role RBAC enforced down to navigation, and an audit module tracing every action. TsaraKonta accounting module: balance sheet, income statement, cash flow, ratios, depreciation and 5-year forecasts. Industrialised with 111 unit tests and a GitHub Actions CI with blocking lint.",
  image: "/assets/img/lahimena/capture1.webp",
  galerie: [
    "/assets/img/lahimena/capture1.webp",
    "/assets/img/lahimena/capture2.webp",
    "/assets/img/lahimena/capture3.webp",
    "/assets/img/lahimena/capture4.webp",
  ],
  // Dépôt passé en privé (propriété du client) : pas de lien, mention explicite.
  privateCode: true,
  technologies: [
    { nom: "Python", image: "/assets/img/icon/stack/python.svg" },
    { nom: "Pandas", image: "/assets/img/icon/stack/pandas.svg" },
    { nom: "CustomTkinter", image: "/assets/img/customtkinter.ico" },
  ],
};

const faceRecognition = {
  id: "face_recognition",
  nom: "Face Recognition",
  description:
    "Logiciel desktop de surveillance avancée intégrant un système de reconnaissance faciale. L’application permet de sécuriser des espaces en déclenchant une alerte lorsqu’un individu non autorisé accède à une zone restreinte. Le système intègre également des fonctionnalités de recherche et de suivi d’individus à partir de vidéos importées ou d’images, à la manière d’un système de tracking intelligent.",
  description_en:
    "An advanced desktop surveillance software integrating facial recognition. The application secures spaces by triggering alerts when unauthorized individuals access restricted areas. The system also integrates search and tracking features for individuals from imported videos or images, like an intelligent tracking system.",
  image: "/assets/img/face_recognition/capture1.webp",
  galerie: [
    "/assets/img/face_recognition/capture1.webp",
    "/assets/img/face_recognition/capture2.webp",
    "/assets/img/face_recognition/capture3.webp",
  ],
  link: "https://github.com/Ravic110/face_recognition",
  linkType: "github",
  technologies: [
    { nom: "Python", image: "/assets/img/icon/stack/python.svg" },
    { nom: "NumPy", image: "/assets/img/icon/stack/numpy.svg" },
    { nom: "Scikit-learn", image: "/assets/img/icon/stack/sklearn.svg" },
    { nom: "OpenCV", image: "/assets/img/icon/stack/python.svg" },
  ],
};

const icl = {
  id: "icl",
  nom: "ICL — Insight Consulting & Learning",
  description:
    "Site vitrine pour un cabinet de conseil et de formation. Une collaboration qui s'est prolongée : après la livraison du site, ICL m'a confié l'animation de ses cursus SQL et Power BI pour le compte du Groupe Axian.",
  description_en:
    "Showcase website for a consulting and training firm. The collaboration went further: after delivering the site, ICL brought me in to run their SQL and Power BI training programmes for Groupe Axian.",
  image: "/assets/img/arkeup/capture1.webp",
  galerie: [
    "/assets/img/arkeup/capture1.webp",
    "/assets/img/arkeup/capture2.webp",
    "/assets/img/arkeup/capture3.webp",
    "/assets/img/arkeup/capture4.webp",
    "/assets/img/arkeup/capture5.webp",
    "/assets/img/arkeup/capture6.webp",
  ],
  link: "https://icl-sarl.com",
  linkType: "website",
  technologies: [
    { nom: "React", image: "/assets/img/icon/stack/react.webp" },
  ],
};

export const PORTFOLIO = [
  businessPlanMg,
  lahimena,
  icl,
  faceRecognition,
];
